// Compiled at 2026-09-18T12:45:23.821Z
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty, jsonArrayProperty, AnyType } from "@sumbricht/json-class-serializer";
import { BoInfoSymbol } from "@lg/shared/for-apps";
import { computed, isSignal } from "../../signals.js";
import { Signals, HasSignalProperties } from "@lg/shared/for-apps";
import { equal } from "@lg/shared/for-apps";
import { immerable } from "immer";
import { untracked } from "@angular/core";
@jsonClass('Orders.VendorOfferItemQuantity')
class Orders__VendorOfferItemQuantity {
    @jsonProperty(() => Orders__VendorOfferItemQuantity.Id)
    id: Orders__VendorOfferItemQuantity.Id;
    static readonly [BoInfoSymbol] = Object.freeze({
        boType: "Entity" as const,
        idType: "number" as const,
        editablePropertyNames: unwrapReadonly(Object.freeze(["id", "quantity", "unitPrice", "unitPriceDiscounted", "unitPriceCustomerCcy", "deliveryTime", "item", "itemId", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        computedPropertyNames: unwrapReadonly(Object.freeze([] as const)),
        allPropertyNames: unwrapReadonly(Object.freeze(["id", "quantity", "unitPrice", "unitPriceDiscounted", "unitPriceCustomerCcy", "deliveryTime", "item", "itemId", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        propertyNamesOfInterest: unwrapReadonly(Object.freeze(["id", "quantity", "unitPrice", "unitPriceDiscounted", "unitPriceCustomerCcy", "deliveryTime", "item", "itemId", "createdOn", "updatedOn", "deletedOn", "versionNumber"] as const)),
        propertyTypes: unwrapReadonly(Object.freeze({ "quantity": "number", "unitPrice": "number", "unitPriceDiscounted": "number", "unitPriceCustomerCcy": "number", "deliveryTime": "string", "item": "Orders.VendorOfferItem", "itemId": "Orders.VendorOfferItem.Id", "createdOn": "Date", "createdBy": "System.UserIdAndName", "updatedOn": "Date", "updatedBy": "System.UserIdAndName", "deletedOn": "Date", "deletedBy": "System.UserIdAndName", "versionNumber": "number", "id": "number" } as const)),
        staticEntityProperties: unwrapReadonly(Object.freeze([] as const)),
        searchInProperties: unwrapReadonly(Object.freeze(["id"] as const)),
        subsetNames: unwrapReadonly(Object.freeze([] as const)),
        manyToOneRelationships: unwrapReadonly(Object.freeze({ item: () => Orders.VendorOfferItem } as const)),
        oneToManyRelationships: unwrapReadonly(Object.freeze({} as const)),
        oneToOneOwningRelationships: unwrapReadonly(Object.freeze({} as const)),
        oneToOneSecondaryRelationships: unwrapReadonly(Object.freeze({} as const)),
        embeddedEntities: unwrapReadonly(Object.freeze({} as const)),
        get allRelationships() {
            return {
                ...this.manyToOneRelationships,
                ...this.oneToManyRelationships,
                ...this.oneToOneOwningRelationships,
                ...this.oneToOneSecondaryRelationships,
            } as const
        },
    });
    static readonly Id = Number;
    readonly [HasSignalProperties] = true;
    [immerable] = true;
    private readonly θquantity = Signals.proxySignalDeferred<number>(() => (undefined) as any);
    private readonly θunitPrice = Signals.proxySignalDeferred<number>(() => (undefined) as any);
    private readonly θunitPriceDiscounted = Signals.proxySignalDeferred<number>(() => (undefined) as any);
    private readonly θunitPriceCustomerCcy = Signals.proxySignalDeferred<number>(() => (undefined) as any);
    private readonly θdeliveryTime = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θitem = Signals.proxySignalDeferred<Orders.VendorOfferItem>(() => (undefined) as any);
    private readonly θitemId = Signals.proxySignalDeferred<Orders.VendorOfferItem.Id>(() => (undefined) as any);
    private readonly θcreatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θcreatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θupdatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θupdatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θdeletedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θdeletedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θversionNumber = Signals.proxySignalDeferred<number>(() => (undefined) as any);

    static get __type(): 'Orders.VendorOfferItemQuantity' {
        return 'Orders.VendorOfferItemQuantity'
    }

    set __type(_) {
    }

    @jsonProperty(String)
    get __type(): 'Orders.VendorOfferItemQuantity' {
        return 'Orders.VendorOfferItemQuantity'
    }

    static get __baseType(): 'Orders.VendorOfferItemQuantity' {
        return 'Orders.VendorOfferItemQuantity'
    }

    set __baseType(_) {
    }

    get __baseType(): 'Orders.VendorOfferItemQuantity' {
        return 'Orders.VendorOfferItemQuantity'
    }

    get [BoInfoSymbol]() {
        return Orders__VendorOfferItemQuantity[BoInfoSymbol]
    }

    get quantity(): number {
        return this.θquantity?.()
    }

    set quantity(quantity) {
        this.θquantity.set(coerceDataType(quantity, 'number', false, true))
    }

    get unitPrice(): number {
        return this.θunitPrice?.()
    }

    set unitPrice(unitPrice) {
        this.θunitPrice.set(coerceDataType(unitPrice, 'number', false, true))
    }

    get unitPriceDiscounted(): number {
        return this.θunitPriceDiscounted?.()
    }

    set unitPriceDiscounted(unitPriceDiscounted) {
        this.θunitPriceDiscounted.set(coerceDataType(unitPriceDiscounted, 'number', false, true))
    }

    get unitPriceCustomerCcy(): number {
        return this.θunitPriceCustomerCcy?.()
    }

    set unitPriceCustomerCcy(unitPriceCustomerCcy) {
        this.θunitPriceCustomerCcy.set(coerceDataType(unitPriceCustomerCcy, 'number', false, true))
    }

    get deliveryTime(): string {
        return this.θdeliveryTime?.()
    }

    set deliveryTime(deliveryTime) {
        this.θdeliveryTime.set(coerceDataType(deliveryTime, 'string', false, true))
    }

    get item(): Orders.VendorOfferItem {
        return this.θitem?.()
    }

    set item(item) {
        this.θitem.set(coerceDataType(item, Orders.VendorOfferItem, false, true))
        if (item) {
            this.θitemId.set(item.id)
        } else if (item === null && item) {
            this.θitemId.set(null)
        }
    }

    get itemId(): Orders.VendorOfferItem.Id {
        return this.θitemId?.()
    }

    set itemId(itemId) {
        if (itemId === null) this.θitem.set(null)
        if (this.item?.id && itemId != this.item.id) throw new Error('Cannot set entity id to a different value than the current entity id')
        this.θitemId.set(coerceDataType(itemId, 'Orders.VendorOfferItem.Id', false, true))
    }

    get createdOn(): Date {
        return this.θcreatedOn?.()
    }

    set createdOn(createdOn) {
        this.θcreatedOn.set(coerceDataType(createdOn, 'Date', false, true))
    }

    get createdBy(): System.UserIdAndName {
        return this.θcreatedBy?.()
    }

    set createdBy(createdBy) {
        this.θcreatedBy.set(coerceDataType(createdBy, 'System.UserIdAndName', false, true))
    }

    get updatedOn(): Date {
        return this.θupdatedOn?.()
    }

    set updatedOn(updatedOn) {
        this.θupdatedOn.set(coerceDataType(updatedOn, 'Date', false, true))
    }

    get updatedBy(): System.UserIdAndName {
        return this.θupdatedBy?.()
    }

    set updatedBy(updatedBy) {
        this.θupdatedBy.set(coerceDataType(updatedBy, 'System.UserIdAndName', false, true))
    }

    get deletedOn(): Date {
        return this.θdeletedOn?.()
    }

    set deletedOn(deletedOn) {
        this.θdeletedOn.set(coerceDataType(deletedOn, 'Date', false, true))
    }

    get deletedBy(): System.UserIdAndName {
        return this.θdeletedBy?.()
    }

    set deletedBy(deletedBy) {
        this.θdeletedBy.set(coerceDataType(deletedBy, 'System.UserIdAndName', false, true))
    }

    get versionNumber(): number {
        return this.θversionNumber?.()
    }

    set versionNumber(versionNumber) {
        this.θversionNumber.set(coerceDataType(versionNumber, 'number', false, true))
    }

    constructor(init?: Partial<Orders__VendorOfferItemQuantity>, initOneToManyRelations = false) {
        if (initOneToManyRelations) {
            init = {
                ...init
            }

        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(Object.getPrototypeOf(this)))) {
            if (pd.get) Object.defineProperty(this, p, { ...pd, enumerable: true })
        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(this))) {
            if (p.startsWith('θ')) Object.defineProperty(this, p, { ...pd, enumerable: false })
        }

        untracked(() => assignCommonProperties(this, init))
        const θinitFn: any = (this as any).init
        if (typeof θinitFn == 'function') θinitFn(init)
    }

    θtoPlainObject(recursive = true, includeType = false) {
        const obj = {}

        for (const key of this.θgetPropertyNames(includeType)) {
            let value = Reflect.get(this, key) as any
            if (recursive && typeof value?.θtoPlainObject == 'function') {
                value = value.θtoPlainObject(recursive, includeType)
            }

            Reflect.set(obj, key, value)
        }

        return obj
    }

    $clone(deep: boolean = true, θcloneMap = new Map<any, any>()) {
        if (θcloneMap.has(this)) return θcloneMap.get(this)
        const clone = new Orders__VendorOfferItemQuantity()
        θcloneMap.set(this, clone)
        function cloneValue(value: any) {
            if (θcloneMap.has(value)) return θcloneMap.get(value)
            if (typeof value?.$clone == "function") {
                return value.$clone(deep, θcloneMap)
            } else if (Array.isArray(value)) {
                return value.map(cloneValue)
            } else if (isSignal(value)) {
                return Signals.proxySignalDeferred(() => cloneValue(value()))
            }

            return value
        }

        if (deep) {
            for (const [key, value] of Object.entries(this)) {
                Reflect.set(clone, key, cloneValue(value))
            }

        }

        return clone
    }

    $updateFrom(source: Partial<Orders__VendorOfferItemQuantity>, restrictToClass?: Class<Partial<Orders__VendorOfferItemQuantity>>) {
        assignCommonProperties(this, source, { restrictToClass })
    }

    θgetPropertyNames(includeType: boolean = false) {
        const names: string[] = []
        names.push('id')
        names.push('quantity', 'unitPrice', 'unitPriceDiscounted', 'unitPriceCustomerCcy', 'deliveryTime', 'item', 'itemId', 'createdOn', 'createdBy', 'updatedOn', 'updatedBy', 'deletedOn', 'deletedBy', 'versionNumber')
        if (includeType) names.push('__type')
        return names
    }

    θcleanupBeforeSave() {
    }

    $equals(other: any): other is Orders__VendorOfferItemQuantity {
        return equal(this, other)
    }
}

namespace Orders__VendorOfferItemQuantity { }

export import VendorOfferItemQuantity = Orders__VendorOfferItemQuantity
setTimeout(() => {
    jsonProperty(() => Number)(Orders__VendorOfferItemQuantity.prototype, 'quantity')
    jsonProperty(() => Number)(Orders__VendorOfferItemQuantity.prototype, 'unitPrice')
    jsonProperty(() => Number)(Orders__VendorOfferItemQuantity.prototype, 'unitPriceDiscounted')
    jsonProperty(() => Number)(Orders__VendorOfferItemQuantity.prototype, 'unitPriceCustomerCcy')
    jsonProperty(() => String)(Orders__VendorOfferItemQuantity.prototype, 'deliveryTime')
    jsonProperty(() => Orders.VendorOfferItem)(Orders__VendorOfferItemQuantity.prototype, 'item')
    jsonProperty(() => Orders.VendorOfferItem.Id)(Orders__VendorOfferItemQuantity.prototype, 'itemId')
    jsonProperty(() => Date)(Orders__VendorOfferItemQuantity.prototype, 'createdOn')
    jsonProperty(() => System.UserIdAndName)(Orders__VendorOfferItemQuantity.prototype, 'createdBy')
    jsonProperty(() => Date)(Orders__VendorOfferItemQuantity.prototype, 'updatedOn')
    jsonProperty(() => System.UserIdAndName)(Orders__VendorOfferItemQuantity.prototype, 'updatedBy')
    jsonProperty(() => Date)(Orders__VendorOfferItemQuantity.prototype, 'deletedOn')
    jsonProperty(() => System.UserIdAndName)(Orders__VendorOfferItemQuantity.prototype, 'deletedBy')
    jsonProperty(() => Number)(Orders__VendorOfferItemQuantity.prototype, 'versionNumber')
})

export const VendorOfferItemQuantityθId = Number;

export type VendorOfferItemQuantityθId = number;

namespace Orders__VendorOfferItemQuantity {
    export type Id = NominalType<number, 'Orders.VendorOfferItemQuantity'>

}
